import React, { ReactNode, ButtonHTMLAttributes, ElementType } from 'react';

import {
  List as ListEmotion,
  Item,
  ItemButton,
  ItemInner,
  Icon,
  Name,
  Caption,
  IconSecond
} from './styles';

export type AlignType = 'baseline' | 'center';

export interface ListProps {
  children: ReactNode;
  height?: number | 'auto';
  paddingItems?: string;
}

export interface ItemProps {
  children: ReactNode;
  rel?: string;
  align?: AlignType;
}

export interface ItemButtonProps {
  children: ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
  as?: ElementType;
  to?: string;
  href?: string;
  target?: string;
  rel?: string;
  align?: AlignType;
}

export function List(props: ListProps) {
  const { height = 'auto', children, paddingItems, ...other } = props;
  return (
    <ListEmotion height={height} paddingItems={paddingItems} {...other}>
      {children}
    </ListEmotion>
  );
}

// List.Item используется для неинтерактивного элемента списка
List.Item = (props: ItemProps) => {
  const { align = 'baseline', ...other } = props;
  return (
    <Item {...other}>
      <ItemInner align={align}>{props.children}</ItemInner>
    </Item>
  );
};

List.ItemButton = (props: ItemButtonProps & ButtonHTMLAttributes<HTMLButtonElement>) => {
  const { as, align = 'baseline', ...other } = props;

  return (
    <ItemButton
      as={as}
      type={!as || as === 'button' ? 'button' : undefined}
      aria-disabled={props.isDisabled}
      {...other}
    >
      <ItemInner align={align}>{props.children}</ItemInner>
    </ItemButton>
  );
};

List.Icon = Icon;
List.Name = Name;
List.Caption = Caption;
List.IconSecond = IconSecond;
